export enum ActivityFilterKey {
  ALL = 'all',
  MINE = 'mine',
}

export type KioskFlexTypeData = {
  enableStudentPhoto: boolean;
};
